import { InsuranceProviders } from '../../../enums/insurance-providers';

import { getRateConfiguration, getSaveAndRateConfiguration, sanitizePackages } from './shipment';

const addLocalDeliverySpecifics = (config, sellerDimensionUnit, enableLocalDeliveryDriverTip) => {
  const shouldIncludeInsuranceValue = false;
  return {
    pickup: config.pickup,
    driverTip: enableLocalDeliveryDriverTip ? config.driverTip : null,
    insuranceProvider: InsuranceProviders.None.name,
    packages: sanitizePackages(config.packages, sellerDimensionUnit, shouldIncludeInsuranceValue),
  };
};

export const getLocalDeliverySaveAndRateConfiguration = (fulfillmentPlan, reduxData) => {
  return {
    ...getSaveAndRateConfiguration(fulfillmentPlan, reduxData),
    ...addLocalDeliverySpecifics(fulfillmentPlan, reduxData.defaultDimensionUnit, reduxData.enableLocalDeliveryDriverTip),
  };
};

export const getLocalDeliveryRateConfiguration = (shippingConfig, reduxData) => {
  return {
    ...getRateConfiguration(shippingConfig, reduxData),
    ...addLocalDeliverySpecifics(shippingConfig, reduxData.defaultDimensionUnit, reduxData.enableLocalDeliveryDriverTip),
  };
};
